module.exports = __webpack_public_path__ + "media/images/emblems/Choulex-coat_of_arms-1d2fb3b62d40a63b52c789e6d66b9346.svg";